import {
  GET_LABREQUESTTESTSAMPLE_FAIL,
  GET_LABREQUESTTESTSAMPLE_SUCCESS,
  GET_LABREQUESTTESTSAMPLES_FAIL,
  GET_LABREQUESTTESTSAMPLES_SUCCESS,
  ADD_LABREQUESTTESTSAMPLE_SUCCESS,
  ADD_LABREQUESTTESTSAMPLE_FAIL,
  UPDATE_LABREQUESTTESTSAMPLE_SUCCESS,
  UPDATE_LABREQUESTTESTSAMPLE_FAIL,
  DELETE_LABREQUESTTESTSAMPLE_SUCCESS,
  DELETE_LABREQUESTTESTSAMPLE_FAIL,  
  SET_STATE_LABREQUESTTESTSAMPLE
} from "./actionTypes";

const INIT_STATE = {
  labRequestTestSamples: [],
  labRequestTestSample: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestTestSamples = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTTESTSAMPLES_SUCCESS:
      return {
        ...state,
        labRequestTestSamples: action.payload.labRequestTestSamples,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTTESTSAMPLE:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTTESTSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestTestSamples: [...state.labRequestTestSamples, action.payload],
      };

    case ADD_LABREQUESTTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestTestSamples: state.labRequestTestSamples.map(labRequestTestSample =>
          labRequestTestSample.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestTestSample }
            : labRequestTestSample
        ),
      };

    case UPDATE_LABREQUESTTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestTestSamples: state.labRequestTestSamples.filter(
          labRequestTestSample => labRequestTestSample.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTTESTSAMPLE_SUCCESS:
      return {
        ...state,
        labRequestTestSample: action.payload,
      };

    case GET_LABREQUESTTESTSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestTestSamples;
